__turbopack_context__.v({
  "checkboxContainer": "styles-module__eomB4q__checkboxContainer",
  "checkboxError": "styles-module__eomB4q__checkboxError",
  "checkboxText": "styles-module__eomB4q__checkboxText",
  "descriptionContainer": "styles-module__eomB4q__descriptionContainer",
  "form": "styles-module__eomB4q__form",
  "formDescription": "styles-module__eomB4q__formDescription",
  "inputContainer": "styles-module__eomB4q__inputContainer",
  "link": "styles-module__eomB4q__link",
  "submit": "styles-module__eomB4q__submit",
  "submitContainer": "styles-module__eomB4q__submitContainer",
});
